export const View = 'div';
//# sourceMappingURL=index.js.map